import React from "react";

import { Box } from "src/components";

// The bottom padding makes sure the keyboard doesn't block data entry on mobile

const BoxWithKeyboardPadding = props => {
  return <Box pb={[400, 0]} {...props} />;
};

export default BoxWithKeyboardPadding;



// WEBPACK FOOTER //
// ./src/banking/components/BoxWithKeyboardPadding.js